import { UIComponentCSSStyle } from "src/com/sixdee/crbtportal/ui/toolkit/uicomponentcss";
import { UIComponentView } from "src/com/sixdee/crbtportal/ui/toolkit/uicomponentview";
import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { DedicateFlashDto } from "src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto";
import { DedicateFlashCardMessageCSSStyleImpl } from "./dedicateflashcardmessagecss";
import { DedicateFlashCardMessageViewImpl } from "./dedicateflashcardmessageview";
import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from "src/com/sixdee/crbtportal/ui/toolkit/uicomponent";

export interface DedicateFlashCardMessageComponentProps extends UIComponentProps
{
    flashDto: DedicateFlashDto;
    onDeleteDedicateClicked(flashDto: DedicateFlashDto): void;
}

export interface DedicateFlashCardMessageComponentState extends UIComponentState
{
    flashDto: DedicateFlashDto;
}

export interface DedicateFlashCardMessageHandler extends UIComponentHandler
{
    onDeleteDedicateClicked(): void;
}

export class DedicateFlashCardMessageComponent extends UIComponentImpl<DedicateFlashCardMessageComponentProps, DedicateFlashCardMessageComponentState, UIDataModel> implements DedicateFlashCardMessageHandler
{
    constructor(props: DedicateFlashCardMessageComponentProps)
    {
        super(props);

        this.state = {flashDto: props.flashDto};
    }
    
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new DedicateFlashCardMessageViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new  DedicateFlashCardMessageCSSStyleImpl(applicationContext);
    }
    onDeleteDedicateClicked(): void {
      this.props.onDeleteDedicateClicked(this.props.flashDto);
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/dedicateflashmessage/dedicatecard/dedicateflashcardmessagecomponent.tsx